import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const EpisodeListIcon: React.FC<Props> = props => {
  const size = props.size || 10;
  const color = props.color || '#ff8f13';
  return <Icon name={'project-episode-list'} size={size} color={color} />;
};

export default React.memo(EpisodeListIcon);
